import * as http from 'axios'

export const getUserByCorpoClinico = (idCorpoClinico) => http.get(`/usuario/?corpoClinico=${idCorpoClinico}`)
export const getUserByRedeAndRoleAdmRede = (idRede) => http.get(`/usuario?rede=${idRede}&role__in=AdmRede,AdminRede`)
export const update = (payload) => http.put(`/usuario/${payload._id}`, payload)
export const save = (payload) => http.post('/users/createUserDrachei', payload)
export const ativar = (payload) => http.post('/users/ativar', payload)
export const saveAdmRede = (payload) => http.post('/usuario', payload)



// WEBPACK FOOTER //
// ./src/store/user/services.js